// third-party
import { FormattedMessage } from 'react-intl';

// assets
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
// type

// icons
const icons = { ContentPasteOutlinedIcon, FileTextOutlined, SettingOutlined };

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const appointments = {
  id: 'appointments',
  title: <FormattedMessage id="Appointments" />,
  icon: icons.ContentPasteOutlinedIcon,
  type: 'group',
  children: [
    {
      id: 'appointment-list',
      title: <FormattedMessage id="OPD Appointments" />,
      type: 'item',
      url: '/appointments/appointment-list',
      icon: icons.ContentPasteOutlinedIcon
    },
    {
      id: 'prescription-templates',
      title: <FormattedMessage id="Prescription Templates" />,
      type: 'item',
      url: '/prescription-templates',
      icon: icons.FileTextOutlined,
      visible: (roles, isAdmin) => roles.includes('doctor') || isAdmin
    },
  ]
};

export default appointments;
